module.exports = __webpack_public_path__ + "static/media/covid_adolescent_p2_2.93b568bc.png";